import React from "react";

const UsageFeeSection = (props) => {
  return (
    <div className="usage-fee-container">
      <div className="title">利用料金について</div>
      <div className="fee">
        1アカウント&nbsp;&nbsp;月額&nbsp;&nbsp;<span>00,000</span>円（税込）
      </div>
      <div className="text">
        ※ご契約は企業単位となり、月額料金に「保守・サポート費」を含みます。
        <br />
        ※ご契約プラン・通数に応じて、追加料金が発生します。
        <br />
        ※その他オプションサービスのご利用に、別途費用が発生します。
        <br />
        <br />
        ご利用状況に応じたコストシミュレーションが可能です。
        <br />
        一度お問い合わせください。
      </div>
    </div>
  );
};

export default UsageFeeSection;
